import { useNavigate } from 'react-router-dom';
import { useAuth, ROLE_HOME } from '@/context/AuthContext';

/**
 * Logo oficial do Kaven (dourado 3D com chama) em PNG transparente.
 * Flutua diretamente sobre o bg da tela, sem container sólido.
 * Drop-shadow sutil para dar profundidade.
 * Clique leva para a home do role logado.
 */
export default function BrandLogo({ className = '', maxWidth = 180 }) {
  const navigate = useNavigate();
  const { operator } = useAuth();

  const goHome = () => {
    const target = operator ? (ROLE_HOME[operator.role] || '/admin') : '/login';
    navigate(target);
  };

  return (
    <button
      data-testid="brand-logo"
      type="button"
      onClick={goHome}
      className={`block mx-auto bg-transparent transition-transform hover:scale-[1.02] active:scale-[0.99] ${className}`}
      aria-label="Kaven Restaurante - Ir para home"
    >
      <img
        data-testid="brand-logo-img"
        src="/logo-transparente.webp"
        alt="Kaven Restaurante"
        className="block mx-auto object-contain"
        style={{
          maxWidth: `${maxWidth}px`,
          width: '100%',
          filter: 'drop-shadow(0 2px 4px rgba(15, 23, 42, 0.12)) drop-shadow(0 1px 2px rgba(15, 23, 42, 0.08))',
        }}
      />
    </button>
  );
}
